<template>
  <!-- 在线律师 -->
  <div class="ranking">
    <div class="rank_title" v-if="showTitle">{{ titleText }}</div>

    <div class="rank_list">
      <div
        v-for="(item, index) in 10"
        :key="index"
        @mouseover="rank_mouse(index)"
      >
        <!-- 未激活 -->
        <div
          v-if="ranking_active != index"
          class="rank_item between"
          :style="{ marginTop: index == 0 ? '0' : '' }"
        >
          <div class="sort center">
            <img src="~assets/home/home_sort_1.png" v-if="index == 0" />
            <img src="~assets/home/home_sort_2.png" v-else-if="index == 1" />
            <img src="~assets/home/home_sort_3.png" v-else-if="index == 2" />
            <div v-else>{{ index + 1 }}</div>
          </div>
          <div class="desc between">
            <div class="flex_start FontSize18">
              <div class="mg_r10">张三</div>
              <div class="zy col9">律师</div>
            </div>
            <div class="FontSize14 col9">223次回复</div>
          </div>
          <div class="icon">
            <img v-if="index % 2 == 0" src="~assets/home/shangsheng.png" />
            <img v-else src="~assets/home/xiajiang.png" />
          </div>
        </div>
        <!-- 激活 -->
        <div
          class="rank_active_item between"
          :style="{ marginTop: index == 0 ? '0' : '' }"
          v-else
        >
          <div class="sort_portrait">
            <img src="~assets/home/lvshi_lv_sample1.png" />
          </div>
          <div class="desc between">
            <div>
              <div class="flex_start FontSize18">
                <div class="mg_r10">张三</div>
                <div class="zy col9">律师</div>
              </div>
              <div class="FontSize12 col9 mg_t8">回复223条</div>
            </div>
            <div class="questions">快速提问</div>
          </div>

          <div class="icon">
            <img v-if="index % 2 == 0" src="~assets/home/shangsheng.png" />
            <img v-else src="~assets/home/xiajiang.png" />
          </div>
        </div>

        <!-- 激活结束 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    titleText: {
      type: String,
      default: "安徽律师好评排行榜",
    },
  },
  data: () => ({
    ranking_active: 0,
  }),
  methods: {
    rank_mouse(index) {
      this.ranking_active = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.ranking {
  text-align: left;
  .rank_title {
    font-size: 20px;
    color: #333333;
    margin-bottom: 20px;
  }
  .rank_list {
    .rank_item {
      margin-top: 14px;
      .sort {
        width: 62px;
        height: 34px;
        text-align: center;
        div {
          width: 26px;
          height: 26px;
          margin: 0 auto;
          line-height: 26px;
          font-size: 14px;
          border-radius: 50%;
          border: 1px solid #bcbcbc;
        }
      }

      .col9 {
        color: #9999;
      }
      .mg_r10 {
        margin-right: 10px;
      }
      .desc {
        width: 70%;
        padding-right: 3px;
        .zy {
          font-size: 16px;
        }
      }
    }
  }

  .rank_active_item {
    margin-top: 14px;
        cursor: pointer;
    .sort_portrait {
      img {
        width: 62px;
        height: 62px;
        border-radius: 50%;
      }
    }
    .desc {
      width: 70%;
      .zy {
        font-size: 16px;
      }
      .col9 {
        color: #9999;
      }
      .mg_r10 {
        margin-right: 10px;
      }
      .mg_t8 {
        margin-top: 8px;
      }
      .questions {
        width: 78px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        border: 1px solid #f25618;
        border-radius: 14px;
        font-size: 14px;
        color: #f25a1d;
        transition: all .2s;
        cursor: pointer;
        &:hover {
          background-color: #f25a1d;
          color: #fff;
        }
      }
    }
  }
}
</style>